import { InventoryHierarchicalItemType, InventoryItemType } from '../inventory/inventory-itemtype';
import { sortBy } from 'lodash-es';

export class HierarchyHelper {

  /**
   * Transform basic inventory types to types with hierarchy informatio.
   * Calculates hierarchy information from the parent_ids of the list of
   * basic item types.
   * @param types list of item types
   */
  typeListToHierarchy(types: InventoryItemType[]): InventoryHierarchicalItemType[] {
    const t = this.calculateHierarchyPath(types);
    return sortBy(t, 'path');
  }

  /**
   * Tansforms to tree.
   * @param types list of item types with hierarchy information
   */
  typesAsTree(types: InventoryHierarchicalItemType[]) {
    for (let i = 0; i < types.length; i++) {
      types[i].children = types[i].children || [];
      types[i].children = types.filter(node => node.parent && node.parent.id === types[i].id);
    }
    const roots = types.filter(node => !node.parent);
    return roots;
  }

  private calculateHierarchyPath(types): InventoryHierarchicalItemType[] {
    return (
      types
        // add the parent items as a list
        .map((cat) => ({ ...cat, parents: this.parents(cat, types) }))
        // create a string field that holds the "path" from root the the item,
        // consisting of the parents' and the item's title
        .map((cat) => ({ ...cat, path: this.pathAsString(cat) }))
    );
  }

  private pathAsString(cat) {
    return cat.parents
      .filter((p) => !p.isAbstract)
      .map((p) => p.title)
      .join('.');
  }

  private lookupParent(cat, types) {
    return cat.parent ? types.find((c) => c.id === cat.parent.id) : null;
  }

  private parents(cat, types) {
    const p = this.lookupParent(cat, types);
    if (p == null) {
      return [this.makeParentObject(cat)];
    }
    return this.parents(p, types).concat([this.makeParentObject(cat)]);
  }

  /**
   * A stripped down version of an inventory type
   * @param cat
   */
  private makeParentObject(cat: { id: string; title: string; isAbstract: boolean }) {
    return {
      id: cat.id,
      title: cat.title,
      isAbstract: cat.isAbstract,
    };
  }
}
